import request from 'superagent';

/*

  the madai convention in order to handle a server error is to return a 500 HTTP error and a JSON
  payload with the following format

  {
    "error": "<error code>"
  }

*/
function createError(res) {
  if (!res.body) {
    return new Error(res.statusText);
  }
  return new Error(res.body.error);
}

function createSuperagentEndCallback(nodeStyleCallback) {
  return (_, res) => {
    if (res.ok) {
      nodeStyleCallback(null, res.body);
    }
    else {
      nodeStyleCallback(createError(res));
    }
  };
}

const noobj = {};

export function post({ url, query = noobj, payload = noobj, type = 'form' }, callback) {
  request
    .post(url)
    .accept('json')
    .type(type)
    .query(query)
    .send(payload)
    .end(createSuperagentEndCallback(callback));
}

export function get({ url, query = noobj }, callback) {
  request
    .get(url)
    .accept('json')
    .type('json')
    .query(query)
    .end(createSuperagentEndCallback(callback));
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/endpoint.js
 **/